import { ApiModel } from './api-model';
import { Value } from './value';
import { Picture } from './picture';
import { Language } from './language';
import { Channel } from './channel';

export class ProgramArticleTranslationValue extends ApiModel {
  id: number;
  title: Value;
  feature: Value;
  longDescription: Value;
  shortDescription: Value;
  picture: Picture;
  isLocked: boolean;
  language: Language;
  pictureOnly: boolean;
}

export class TranslationListByField extends ApiModel {
  fieldName: string;
  inputType: string;
  translations: ProgramArticleTranslationETTValue[];
}

export class ProgramArticleTranslationETTValue extends ApiModel {
  name: string;
  content: string;
  order: number;
  language: Language;
  maxLength: number;
  inputType: string;
  isLocked: boolean;
  fieldName: string;
  programFieldId: number;
}

export class ProgramArticlePictureETTValue extends ApiModel {
  pictureURL: string;
  pictureId: number;
  pictureFormatName: string;
  pictureFormatCode: string;
  pictureFormatId: number;
  pictureSetId: number;
  language: Language;
  channel: Channel;
  blob: string;
  isLocked: boolean;
  modified: boolean;
  source: boolean;
  checked: boolean;
  selectable: boolean;
  selected: boolean;
  displayLocked: boolean;
  duplicatedFromLanguage: Language;

  constructor(data: any) {
    super(data);
    this.pictureId =  data.pictureId ? data.pictureId : -1;
    this.pictureURL = data.pictureURL ? data.pictureURL : "";
    this.blob = this.blob ? this.blob : null;
    this.pictureFormatCode = data.pictureFormatCode;
    this.pictureFormatName = data.pictureFormatCode;
    this.pictureSetId = data.pictureSetId
  }
}


// WEBPACK FOOTER //
// ./src/app/models/program-article-translation-value.ts